import React from 'react';
import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import camera from 'four-nets/icons/svg/icon_photo-outlined.svg';

import defaultStyles from './image-input.scss';
import { FormattedMessage } from 'react-intl';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    inputKey?: React.Key;
    styles: typeof defaultStyles;
}

class ImageInput extends React.PureComponent<Props> {
    render() {
        const { styles, inputKey, children, ...rest } = this.props;

        return (
            <div className={styles.container}>
                <label htmlFor={`image-input-id-${inputKey}`} className={styles.label}>
                    <FormattedMessage id='BUTTON_LABEL_ADD_FILE' />
                </label>
                <input
                    id={`image-input-id-${inputKey}`}
                    key={inputKey}
                    accept='image/gif, image/jpeg, image/jpg, image/png' // we do not accept .svg images
                    {...rest}
                    type='file'
                    className={styles.input}
                />
                <span className={styles.icon}>
                    <SVGIcon style={{ image: styles.camera }} src={camera} />
                </span>
                {children}
            </div>
        );
    }
}

export default Styled(defaultStyles)(ImageInput);
